<template>
	<div>
		<o-checkbox v-model="attrs.options.usePageFilter">Use Page filter</o-checkbox>
		<div v-show="!attrs.options.usePageFilter">
			<o-field label="Select content">
				<o-select v-model="attrs.kind">
					<option value="dynamic">Dynamic</option>
					<option value="manual">Manual</option>
				</o-select>
			</o-field>
			<div>
				<div v-if="attrs.kind == 'manual'">
					<o-field label="Selected content">
						<draggable :list="attrs.content"
								   item-key="uuid">
							<template #item="{ element }">
								<div class="tag mx-2 my-2 draggable">
									{{ ShortenTitle(element.title) }}
									<span class="normal">
										<a role="button"
										   aria-label="Close tag"
										   tabindex="0"
										   class="delete is-small"
										   @click="RemoveRowManual(element)"></a>
									</span>
								</div>
							</template>
						</draggable>
					</o-field>
					<o-input
						v-model="manualFilter"
						placeholder="Search"
						icon="search"
						class="mb-2"
						@input="RefreshCandidates"></o-input>

					<o-field grouped>
						<o-input
							v-model="filter"
							size="small"
							placeholder="Filter"
							icon-right="times-circle"
							icon-right-clickable
							@icon-right-click="ClearFilter"></o-input>
						<o-checkbox v-model="internal">Internal</o-checkbox>
						<o-checkbox v-model="external">External</o-checkbox>
					</o-field>
					<loading v-if="loading"></loading>
					<div v-else style="max-height: 500px; overflow-y: auto">
						<o-table
							:data="acOptions"
							:paginated="isPaginated"
							:pagination-simple="true"
							:per-page="perPage"
							:defaultSort="['title', 'asc']">
							<template #empty>Please search for content</template>
							<template #default>
								<o-table-column field="title" label="Title" sortable v-slot="props">
									{{ props.row.title }}
									<span v-if="props.row.VueRouterName">
										<o-icon icon="info-circle"></o-icon>
										({{ props.row.VueRouterName }})
									</span>
								</o-table-column>
								<o-table-column field="uuid" v-slot="props">
									<o-button
										variant="success"
										inverted
										:disabled="attrs.content.some((x) => x.uuid == props.row.uuid)"
										@click="AddRow(props.row)">
										Select
									</o-button>
								</o-table-column>
							</template>
						</o-table>
					</div>
				</div>
				<div v-if="attrs.kind == 'dynamic'">
					<content-filter v-model="attrs.options"></content-filter>
				</div>
			</div>
		</div>
		<o-field label="Display">
			<o-select v-model="attrs.display">
				<option value="title">Title</option>
				<option value="description">Title + Description</option>
				<option value="vertical">Vertical</option>
				<option value="horizontal">Horizontal</option>
				<option value="tile">Tile</option>
			</o-select>
		</o-field>
		<o-field label="Limit">
			<o-input type="number" v-model="attrs.options.limit"></o-input>
		</o-field>
	</div>
</template>
<script>
	import { onMounted, ref, inject, computed, watch } from "vue";
    import draggable from "vuedraggable";
	import contentFilter from "../filter/contentFilter.vue";

	export default {
		props: {
			modelValue: {
				//attrs
				type: Object,
				default: () => {
					return {};
				}
			},
			pageId: {
				type: String,
				default: undefined
			}
		},
		components: { draggable, contentFilter },
		emits: ["update:modelValue"],
		setup(props, context) {
			const http = inject("$http");

			const internal = ref(true);
			const external = ref(true);
			const filter = ref("");

			const loading = ref(true);

			const attrs = ref(props.modelValue || { kind: "dynamic", content: [], options: {} });

			if (!attrs.value.kind) {
				attrs.value.kind = "dynamic";
			}
			if (!attrs.value.content) {
				attrs.value.content = [];
			}
			if (!attrs.value.options) {
				attrs.value.options = { limit: 2, usePageFilter: true };
			}
			//if (attrs.value.usePageFilter === null || attrs.value.userPageFilter === undefined) {
			//	attrs.value.usePageFilter = true;
			//}

			const manualFilter = ref();
			const candidates = ref([]);

			const perPage = ref(50);
			const isPaginated = computed(() => {
				return (candidates?.value?.length || 0) > perPage.value;
			});

			const ClearFilter = () => {
				filter.value = "";
			};

			const GetPromoCandidates = async () => {
				loading.value = true;
				try {
					const response = await http.get(
						"/api/v2/widget/promos?keyword=" + (manualFilter.value || "")
					);
					candidates.value = response.data
						.map((row) => {
							return {
								oid: row.oid,
								uuid: row.uuid,
								type: row.type.Identifier,
								typeText: row.type.Title,
								typeUUID: row.type.UUID,
								VueRouterName: row.VueRouterName,
								title: row.title
							};
						})
						.reduce((acc, row) => {
							acc.push(row);
							return acc;
						}, []);
				} catch (err) {
					//error.value = err.response.data;
					console.error(err);
				}
				loading.value = false;
			};

			let refreshingCandidates = null;
			const RefreshCandidates = () => {
				if (refreshingCandidates) clearTimeout(refreshingCandidates);
				refreshingCandidates = setTimeout(async () => {
					await GetPromoCandidates();
				}, 500);
			};

			const UpdateModel = () => {
				context.emit("update:modelValue", attrs.value);
			};

			const AddRow = (row) => {
				attrs.value.content.push({
					oid: row.oid,
					uuid: row.uuid,
					title: row.title,
					type: {
						UUID: row.typeUUID,
						Identifier: row.type,
						Title: row.typeText
					}
				});
			};

			const RemoveRow = (index) => {
				attrs.value.content.splice(index, 1);
			};

			const RemoveRowManual = (el) => {
				const index = attrs.value.content.findIndex(item => item.uuid == el.uuid);
				console.log(index);
				attrs.value.content.splice(index, 1);
			};

			const ShortenTitle = (s) => {
				const length = 30;
				if (s.length > length) {
					return s.substr(0, length) + "..";
				} else return s;
			};

			const acText = ref("");
			const RefineAC = (text) => {
				acText.value = text;
			};

			onMounted(async () => {
				await GetPromoCandidates();
				loading.value = false;
			});

			const content = computed(() => {
				return attrs.value.content || [];
			});

			const acOptions = computed(() => {
				const arr = [];
				return candidates.value.filter(
					(x) =>
						(x.title || "").toUpperCase().includes((acText.value || "").toUpperCase()) &&
						!attrs.value.content.some((y) => x.oid === y.oid) &&
						((internal.value == true && x.type == "OlympusWebPage") ||
							(external.value == true && x.type != "OlympusWebPage")) &&
						(filter.value == "" ||
							x.title.toUpperCase().indexOf(filter.value.toUpperCase()) >= 0 ||
							(x.VueRouterName &&
								x.VueRouterName.toUpperCase().indexOf(filter.value.toUpperCase()) >= 0))
				);
			});

			watch(
				() => attrs.value,
				(n, o) => {
					if (n !== o) {
						UpdateModel();
					}
				},
				{ deep: true }
			);

			return {
				loading,
				internal,
				external,
				filter,
				ClearFilter,
				manualFilter,
				candidates,
				attrs,
				content,
				acText,
				acOptions,
				perPage,
				isPaginated,
				RefreshCandidates,
				AddRow,
				RemoveRow,
                RemoveRowManual,
				ShortenTitle,
				RefineAC
			};
		}
	};
</script>
<style lang="scss" scoped>
	.tag {
		box-shadow: 0 2px 5px #aeaeae;
	}

	.draggable {
		cursor: grab;
		&>.normal {
			cursor:default;
		}
	}
</style>
